/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Listing_Extra_Info_SavedInputs */

const cs_portals_listing_extra_info_saved = /** @type {(inputs: Portals_Listing_Extra_Info_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav nabídky na portálu uložen`)
};

const en_portals_listing_extra_info_saved = /** @type {(inputs: Portals_Listing_Extra_Info_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal listing status saved`)
};

/**
* | output |
* | --- |
* | "Portal listing status saved" |
*
* @param {Portals_Listing_Extra_Info_SavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_listing_extra_info_saved = /** @type {((inputs?: Portals_Listing_Extra_Info_SavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Listing_Extra_Info_SavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_listing_extra_info_saved(inputs)
	return cs_portals_listing_extra_info_saved(inputs)
});